import React, { useState } from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ChatIcon from "@mui/icons-material/Chat";
import {
  Box,
  Container,
  Typography,
  Link,
  IconButton,
  Stack,
  Grid,
  Button,
  TextField,
} from "@mui/material";

export default function Footer() {

  const [email, setEmail] = useState("");

  const validateEmail = (email) => {
    // Regex sederhana untuk validasi format email
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubscribe = async () => {
    if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch('https://backend-mypf88.vercel.app/api/subscribe-add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      alert(data.message);
      if (response.ok) {
        setEmail(''); // Kosongkan input jika berhasil
      }
    } catch (error) {
      alert("Something went wrong.");
    }
  };

  return (
    <Box
      sx={{
        mt: 10,
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        color: "#fff",
        py: 6,
        px: 2,
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="flex-start" justifyContent="space-between">
          {/* Kiri: Logo dan Email */}
          <Grid item xs={12} md={4}>
            <Box>
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 0.5 }}>
                    <Box component="img"
                        src="/images/logo192.png"
                        alt="Logo ESM"
                        sx={{ width: 110, height: 110, mb: 0.5 }}
                    />
                </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                <Link
                    href="mailto:elchan99@gmail.com"
                    color="inherit"
                    underline="hover"
                    sx={{ display: "inline-flex", alignItems: "center" }}
                >
                    📧 elchan99@gmail.com
                </Link>
              </Typography>
            </Box>
          </Grid>

          {/* Tengah: Useful Links dan Follow Us */}
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={5} justifyContent="center">
              {/* Useful Links */}
              <Box>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Useful Links :
                </Typography>
                <Stack spacing={2}>
                  <Link href="/about" underline="hover" color="inherit">
                    About
                  </Link>
                  <Link href="/projects" underline="hover" color="inherit">
                    Projects
                  </Link>
                  <Link href="/contact" underline="hover" color="inherit">
                    Contact
                  </Link>
                </Stack>
              </Box>

              {/* Follow Us */}
              <Box>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Follow US :
                </Typography>
                <Stack direction="column" spacing={1} alignItems="center">
                    <Box textAlign="center">
                        <IconButton
                        component="a"
                        href="https://github.com/leosan8899"
                        target="_blank"
                        sx={{ color: "#fff" }}
                        >
                        <Stack direction="row" spacing={1} alignItems="center">
                            <GitHubIcon fontSize="medium" />
                            <Typography variant="body2">GitHub</Typography>
                        </Stack>
                        </IconButton>
                    </Box>
                    <Box textAlign="center">
                        <IconButton
                        component="a"
                        href="https://www.linkedin.com/in/soesanto-djoni-37048555/?trk=public-profile-join-page"
                        target="_blank"
                        sx={{ color: "#fff" }}
                        >
                        <Stack direction="row" spacing={1} alignItems="center">  
                            <LinkedInIcon fontSize="medium" />
                            <Typography variant="body2">linkedin</Typography>
                        </Stack>  
                        </IconButton>
                    </Box>
                </Stack>
              </Box>
            </Stack>
          </Grid>

          {/* Kanan: Newsletter */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Newsletter
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Subscribe to our newsletter
            </Typography>
            <Stack direction="row" spacing={1}>
            <TextField
                variant="outlined"
                placeholder="Enter your email"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  flexGrow: 1,
                }}
              />
              <Button
                variant="contained"
                onClick={handleSubscribe}
                sx={{
                  backgroundColor: "#fff",
                  color: "#ff416c",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#ff416c",
                    color: "#fff",
                  },
                }}
              >
                Subscribe
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box textAlign="center" sx={{ opacity: 0.7 }}>
          <Typography variant="body2">
            &copy; 2022 by Elite Software Makers — All rights reserved.
          </Typography>
        </Box>
      </Container>

      {/* Floating Chat Button */}
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 999,
        }}
      >
        <Button
          variant="contained"
          startIcon={<ChatIcon />}
          sx={{
            background: "#fff",
            color: "#ff416c",
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {
              background: "#ff416c",
              color: "#fff",
            },
            boxShadow: 3,
          }}
          href="whatsapp://send?text=Halo%20Admin%20Program%20Kasir&phone=+62811784971"
        >
          Chat with Me
        </Button>
      </Box>
    </Box>
  );
}
